// Define color list
export const COLORS = [
    {
        Code: '001',
        Description: 'alpinweiss',
        Hex: '#ffffff'
    },
    {
        Code: '002',
        Description: 'schwarz',
        Hex: '#1f1e19'
    },
    {
        Code: '003',
        Description: 'schwarz matt',
        Hex: '#1f1e19'
    },
    {
        Code: '008',
        Description: 'curry',
        Hex: '#d2b318'
    },
    {
        Code: '010',
        Description: 'natura',
        Hex: '#af9f7d'
    },
    {
        Code: '011',
        Description: 'bahamabeige',
        Hex: '#d2b48c'
    },
    {
        Code: '012',
        Description: 'moosgrün',
        Hex: '#948f55'
    },
    {
        Code: '019',
        Description: 'ruby red',
        Hex: '#861a22'
    },
    {
        Code: '020',
        Description: 'star-white',
        Hex: '#e5e2d1'
    },
    {
        Code: '031',
        Description: 'bermudablau',
        Hex: '#597175'
    },
    {
        Code: '032',
        Description: 'caramel',
        Hex: '#896243'
    },
    {
        Code: '033',
        Description: 'manhattan',
        Hex: '#c0c0c0'
    },
    {
        Code: '034',
        Description: 'sunset',
        Hex: '#a38216'
    },
    {
        Code: '035',
        Description: 'evergreen',
        Hex: '#094903'
    },
    {
        Code: '038',
        Description: 'rose-perle',
        Hex: '#bda392'
    },
    {
        Code: '040',
        Description: 'whisperblau',
        Hex: '#e6e6fa'
    },
    {
        Code: '043',
        Description: 'pergamon',
        Hex: '#fffacd'
    },
    {
        Code: '044',
        Description: 'capri',
        Hex: '#adb0a9'
    },
    {
        Code: '046',
        Description: 'greenwich',
        Hex: '#a2b3a0'
    },
    {
        Code: '047',
        Description: 'calypso',
        Hex: '#507f75'
    },
    {
        Code: '048',
        Description: 'ägäis',
        Hex: '#dae5e0'
    },
    {
        Code: '049',
        Description: 'key-west',
        Hex: '#929397'
    },
    {
        Code: '052',
        Description: 'crocus',
        Hex: '#a2b1ec'
    },
    {
        Code: '054',
        Description: 'magnolia',
        Hex: '#d0b1e5'
    },
    {
        Code: '055',
        Description: 'jasmin',
        Hex: '#b6aae3'
    },
    {
        Code: '058',
        Description: 'alpinweiss matt',
        Hex: '#ffffff'
    },
    {
        Code: '060',
        Description: 'hellgrau matt',
        Hex: '#9E9E9E'
    },
    {
        Code: '061',
        Description: 'dunkelgrau matt',
        Hex: '#5D5D5D'
    },
    {
        Code: '062',
        Description: 'anthrazit matt',
        Hex: '#232323'
    },
    {
        Code: '063',
        Description: 'braun matt',
        Hex: '#453234'
    },
    {
        Code: '064',
        Description: 'beige matt',
        Hex: '#E2C8B2'
    },
    {
        Code: '065',
        Description: 'hellbeige matt',
        Hex: '#EFE9DB'
    },
    {
        Code: '066',
        Description: 'graphite matt',
        Hex: '#77726b'
    },
    {
        Code: '067',
        Description: 'silver matt',
        Hex: '#cfc9c5'
    },
    {
        Code: '068',
        Description: 'dust matt',
        Hex: '#c4bab9'
    },
    {
        Code: '069',
        Description: 'cashmere matt',
        Hex: '#a89f95'
    },
    {
        Code: '070',
        Description: 'stone matt',
        Hex: '#9c9890'
    },
    {
        Code: '071',
        Description: 'hazel matt',
        Hex: '#94867b'
    },
    {
        Code: '073',
        Description: 'greige matt',
        Hex: '#a99582'
    },
    {
        Code: '075',
        Description: 'taupe matt',
        Hex: '#766c60'
    },
    {
        Code: '076',
        Description: 'cream matt',
        Hex: '#e8dfd2'
    },
    {
        Code: '077',
        Description: 'cemento satinato',
        Hex: '#8d8882'
    },
    {
        Code: '090',
        Description: 'chrome-plated',
        Hex: '#818181'
    },
    {
        Code: '091',
        Description: 'gold-plated',
        Hex: '#d2b318'
    },
    {
        Code: '093',
        Description: 'bronze eloxadized',
        Hex: '#ffc269'
    },
    {
        Code: '094',
        Description: 'velour chromed',
        Hex: '#8f8f8f'
    },
    {
        Code: '100',
        Description: 'signal red (RAL 3001)',
        Hex: '#9b2423'
    },
    {
        Code: '101',
        Description: 'green beige (RAL 1000)',
        Hex: '#cdba88'
    },
    {
        Code: '102',
        Description: 'pearl white (RAL 1013)',
        Hex: '#e3d9c6'
    },
    {
        Code: '103',
        Description: 'ruby red (RAL 3003)',
        Hex: '#861a22'
    },
    {
        Code: '104',
        Description: 'purple violet (RAL 4007)',
        Hex: '#47243c'
    },
    {
        Code: '105',
        Description: 'ultramarine blue (RAL 5002)',
        Hex: '#00387b'
    },
    {
        Code: '106',
        Description: 'azure blue (RAL 5009)',
        Hex: '#225f78'
    },
    {
        Code: '107',
        Description: 'gentian blue (RAL 5010)',
        Hex: '#004f7c'
    },
    {
        Code: '108',
        Description: 'steel blue (RAL 5011)',
        Hex: '#1a2b3c'
    },
    {
        Code: '109',
        Description: 'light blue (RAL 5012)',
        Hex: '#0089b6'
    },
    {
        Code: '110',
        Description: 'water blue (RAL 5021)',
        Hex: '#007577'
    },
    {
        Code: '111',
        Description: 'leaf green (RAL 6002)',
        Hex: '#325928'
    },
    {
        Code: '112',
        Description: 'mossy green (RAL 6005)',
        Hex: '#114232'
    },
    {
        Code: '113',
        Description: 'yellow green (RAL 6018)',
        Hex: '#61993b'
    },
    {
        Code: '114',
        Description: 'white green (RAL 6019)',
        Hex: '#b9ceac'
    },
    {
        Code: '115',
        Description: 'fern green (RAL 6025)',
        Hex: '#5e6e3b'
    },
    {
        Code: '116',
        Description: 'light green (RAL 6027)',
        Hex: '#5e6e3b'
    },
    {
        Code: '117',
        Description: 'olive gray (RAL 7002)',
        Hex: '#817863'
    },
    {
        Code: '118',
        Description: 'signal gray (RAL 7004)',
        Hex: '#9b9b9b'
    },
    {
        Code: '119',
        Description: 'basalt gray (RAL 7012',
        Hex: '#575d5e'
    },
    {
        Code: '120',
        Description: 'graphite gray (RAL 7024)',
        Hex: '#45494e'
    },
    {
        Code: '121',
        Description: 'light gray (RAL 7035)',
        Hex: '#c5c7c4'
    },
    {
        Code: '122',
        Description: 'dust gray (RAL 7037)',
        Hex: '#7a7b7a'
    },
    {
        Code: '123',
        Description: 'agate gray (RAL 7038)',
        Hex: '#b0b0a9'
    },
    {
        Code: '124',
        Description: 'quartz gray (RAL 7039)',
        Hex: '#6b665e'
    },
    {
        Code: '125',
        Description: 'telegray 4 (RAL 7047)',
        Hex: '#c8c8c7'
    },
    {
        Code: '126',
        Description: 'gray white (RAL 9002)',
        Hex: '#d7d5cb'
    },
    {
        Code: '127',
        Description: 'tannengrün glanz (RAL 6009)',
        Hex: '#31372b'
    },
    {
        Code: '800',
        Description: 'ground coat enamel',
        Hex: '#505050'
    },
    {
        Code: '900',
        Description: 'no colour',
        Hex: '#909090'
    },
    {
        Code: '999',
        Description: 'Spezialfarbe',
        Hex: '#ffffff'
    }
];

/**
 * getColor
 *
 * @param {string} color code
 * @param {Array} color list
 * @param {string} color object prop
 * @returns {string} color object prop
 *
 */
export const getColor = (selectedColor, colorList = `${COLORS}`, criteria = 'Hex') => {
    return colorList.find((color) => {
        return color.Code === selectedColor;
    })[criteria];
}



// WEBPACK FOOTER //
// ./src/utils/colors.js